import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getShopSectionInitActions(responseData, requestParams) {
  return [
    getSectionLayoutInitAction(responseData, 'shop'),
    ...getAllModulesInitActions(responseData, requestParams),
  ].filter(action => action);
}
